import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
const AppIconsCart = React.forwardRef((props: SvgIconProps, ref: any) => {
  return (
    <SvgIcon {...props} ref={ref}>


      <g fill="currentColor">
	<path  d="M7.1813498,0.4565609L2.8297873,4.2798996v19.1784325h17.7446823V0.4565609H7.1813498z M7.0670156,1.8400058
		v2.6319747H4.0760307L7.0670156,1.8400058z M19.5546074,22.5093575H3.7764757V5.3454947h4.2372284V1.4009619h11.5409031V22.5093575
		z"/>
	<rect x="6.3375635" y="8.5628605"  width="6.2792382" height="0.9466884"/>
	<rect x="6.3375635" y="11.4829578"  width="11.2436342" height="0.9466884"/>
	<rect x="6.3375635" y="14.4030561"  width="11.2436342" height="0.9466884"/>
	<rect x="6.3375635" y="17.3986149"  width="11.2436342" height="0.9466884"/>
	<rect x="6.3375635" y="20.3209991"  width="11.2436342" height="0.9466884"/>
</g>

    </SvgIcon>
  );
});

export default AppIconsCart;
